// extracted by mini-css-extract-plugin
export default {"container":"MenuContent_container__pacou","active":"MenuContent_active__qcfw+"};